export const AGNT_IR_EMAIL = 'investors@AGNTinc.com';
export const AGNT_IR_MAILTO = `mailto:${AGNT_IR_EMAIL}`;
